function getText (binding) {
    if (binding.value == null) return ''
    return String(binding.value)
}

export default {
    mounted (el, binding) {
        el.setAttribute('title', getText(binding))
    },
    updated (el, binding) {
        el.setAttribute('title', getText(binding))
    },
    unmounted (el) {
        el.removeAttribute('title')
    }
}
